var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_677_1055",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 21,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7273 2.5C14.9498 2.5 16.9543 3.26581 18.576 4.53508L16.3641 6.74695C15.3408 6.02373 14.0927 5.59091 12.7273 5.59091C9.17841 5.59091 6.31819 8.45113 6.31819 12C6.31819 15.5489 9.17841 18.4091 12.7273 18.4091C15.6755 18.4091 18.022 16.8886 18.5808 14.1453L18.703 13.5455H18.0909H13.2273V10.6818H21.6392C21.7224 11.1268 21.7727 11.5796 21.7727 12C21.7727 18.0722 17.4667 21.5 12.7273 21.5C7.45797 21.5 3.22728 17.2693 3.22728 12C3.22728 6.73069 7.45797 2.5 12.7273 2.5Z",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_677_1055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.72215 11.9999L2.31799 16.8972V7.10261L8.72215 11.9999Z",
    stroke: "#00A991"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_677_1055",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 21,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0455 10.1818H12.7273V14.0455H18.0909C17.5909 16.5 15.5 17.9091 12.7273 17.9091C9.45455 17.9091 6.81819 15.2727 6.81819 12C6.81819 8.72727 9.45455 6.09091 12.7273 6.09091C14.1364 6.09091 15.4091 6.59092 16.4091 7.4091L19.3182 4.5C17.5455 2.95455 15.2727 2 12.7273 2C7.18183 2 2.72728 6.45455 2.72728 12C2.72728 17.5455 7.18183 22 12.7273 22C17.7273 22 22.2727 18.3636 22.2727 12C22.2727 11.4091 22.1818 10.7727 22.0455 10.1818Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_677_1055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.81799 6.09082L9.54527 11.9999L12.7271 9.2272L23.6362 7.45446V1.09082H1.81799V6.09082Z",
    fill: "#EA4335"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_677_1055",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 21,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0455 10.1818H12.7273V14.0455H18.0909C17.5909 16.5 15.5 17.9091 12.7273 17.9091C9.45455 17.9091 6.81819 15.2727 6.81819 12C6.81819 8.72727 9.45455 6.09091 12.7273 6.09091C14.1364 6.09091 15.4091 6.59092 16.4091 7.4091L19.3182 4.5C17.5455 2.95455 15.2727 2 12.7273 2C7.18183 2 2.72728 6.45455 2.72728 12C2.72728 17.5455 7.18183 22 12.7273 22C17.7273 22 22.2727 18.3636 22.2727 12C22.2727 11.4091 22.1818 10.7727 22.0455 10.1818Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_677_1055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.81799 17.909L15.4544 7.45446L19.0453 7.909L23.6362 1.09082V22.909H1.81799V17.909Z",
    fill: "#34A853"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_677_1055",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 21,
    height: 20
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0455 10.1818H12.7273V14.0455H18.0909C17.5909 16.5 15.5 17.9091 12.7273 17.9091C9.45455 17.9091 6.81819 15.2727 6.81819 12C6.81819 8.72727 9.45455 6.09091 12.7273 6.09091C14.1364 6.09091 15.4091 6.59092 16.4091 7.4091L19.3182 4.5C17.5455 2.95455 15.2727 2 12.7273 2C7.18183 2 2.72728 6.45455 2.72728 12C2.72728 17.5455 7.18183 22 12.7273 22C17.7273 22 22.2727 18.3636 22.2727 12C22.2727 11.4091 22.1818 10.7727 22.0455 10.1818Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_677_1055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6364 22.909L9.54546 11.9999L7.72728 10.6363L23.6364 6.09082V22.909Z",
    fill: "#4285F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.887b057970f642f06a6e7960f6699561.svg";
export { ForwardRef as ReactComponent };